import { type CommonRequestFn } from "@marketplace/http";

import { ENDPOINTS } from "@/constants/endpoints";
import { httpClient } from "@/http";
import type {
  GeneratePresignedUrlRequestDto,
  GeneratePresignedUrlResponseDto,
  UploadMediaRequestDto,
  UploadMediaResponseDto
} from "@/types";

type MediaServiceContract = {
  generatePresignedUrl: CommonRequestFn<
    GeneratePresignedUrlRequestDto,
    GeneratePresignedUrlResponseDto
  >;
  uploadMedia: CommonRequestFn<UploadMediaRequestDto, UploadMediaResponseDto>;
};

export const MediaService: MediaServiceContract = {
  generatePresignedUrl: async ({ payload, options }) => {
    return httpClient
      .post(ENDPOINTS.MEDIA.PRESIGNED_URL, {
        ...options,
        json: payload
      })
      .json<GeneratePresignedUrlResponseDto>();
  },

  uploadMedia: async ({ payload, options }) => {
    const formData = new FormData();
    formData.append("file", payload.file, payload.file.name);
    formData.append("type", payload.type);
    formData.append("object_type", payload.object_name);
    formData.append("object_name", payload.object_name);
    if (payload.reference_no) {
      formData.append("reference_no", payload.reference_no);
    }

    return await httpClient
      .post(ENDPOINTS.MEDIA.UPLOAD, {
        ...options,
        body: formData,
        redirect: "follow"
      })
      .json<UploadMediaResponseDto>();
  }
};
